<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="活动名称">
              <a-input
                v-model="queryParam.activityName"
                placeholder="请输入活动名称"
              />
            </a-form-item>
          </a-col>
          <!--<a-col :md="6" :sm="12">
            <a-form-item label="启用状态">
              <j-dict-select-tag v-model="queryParam.status" placeholder="请选择启用状态" dictCode="obj_status"/>
            </a-form-item>
          </a-col>-->
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无图片</span
          >
          <img
            v-else
            :src="getAvatarView(record.activityImage)"
            height="50px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无文件</span
          >
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)"
          >
            下载
          </a-button>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-switch
            :checked="isChecked(record.status)"
            checked-children="启用"
            un-checked-children="未启用"
            @click="handleChange(record)"
          />
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a @click="handleDelete(record.id)">删除</a>
        </span>
      </a-table>
    </div>

    <gold-mall-activity-modal
      ref="modalForm"
      @ok="modalFormOk"
    ></gold-mall-activity-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
// import { mixinDevice } from '@/utils/mixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import GoldMallActivityModal from './modules/GoldMallActivityModal';
import { postAction } from '../../../api/manage';
import customRender from '@/utils/customRender.js';

export default {
  name: 'GoldMallActivity',
  mixins: [JeecgListMixin],
  components: {
    GoldMallActivityModal,
  },
  data() {
    return {
      description: '积分商城活动管理页面',
      loading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      // 表头
      columns: [
        {
          title: '活动名称',
          align: 'center',
          dataIndex: 'activityName',
          customRender: function (text) {
            return !text
              ? ''
              : text.length > 12
              ? text.substr(0, 12) + '...'
              : text;
          },
        },
        {
          title: '活动简介',
          align: 'center',
          dataIndex: 'activityDescribe',
          ellipsis: true,
          customRender: customRender,
          // customRender: function (text) {
          //   return !text
          //     ? ''
          //     : text.length > 15
          //     ? text.substr(0, 15) + '...'
          //     : text;
          // },
        },
        {
          title: '活动图片',
          align: 'center',
          dataIndex: 'activityImage',
          height: '50px',
          width: '150px',
          scopedSlots: { customRender: 'imgSlot' },
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
        },
        /*{
            title:'启用状态',
            align:"center",
            dataIndex: 'status_dictText',
          },*/
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      dataSource: [],
      url: {
        list: process.env.VUE_APP_CMS_MARKETING + '/gold/marketing/list',
        delete: process.env.VUE_APP_CMS_MARKETING + '/gold/marketing/delete',
        edit: process.env.VUE_APP_CMS_MARKETING + '/gold/marketing/edit',
        deleteBatch:
          process.env.VUE_APP_CMS_MARKETING + '/gold/marketing/deleteBatch',
      },
      dictOptions: {},
    };
  },
  computed: {},
  methods: {
    getAvatarView: function (avatar) {
      return process.env.VUE_APP_FILE_PATH + avatar;
    },
    // 单个删除
    handleDelete: function (id) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!');
        return;
      }
      var that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function () {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.loadData(1);
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    // 批量删除
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData(1);
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
    initDictConfig() {},
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.loadData();
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
